import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  FormControl,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import FileUploader from "../../Components/UI/FileUploader";
import Select from "react-select";
import { Back, Folder, House } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import {
  getAdvertiser,
  getS3FilesAndFoldersAction,
  validateFolderNameAction,
  uploadToDSP,
  uploadToS3,
  getLineItems,
} from "../../Redux/Actions/CreativeUploadActions";
import Spinner from "../../Components/UI/Spinner/Spinner";
import * as yup from "yup";
import axios from '../../axiosConfig';
import moment from "moment";



function ModalImageShow(props:any) {
  return (
      <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
      >
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
              <img src={props.imgShowURL} alt={props.imgShowURL?'S3 Image':"Image Not Found"}  className="img-fluid" />
          </Modal.Body>
          <Modal.Footer>
              <Button onClick={props.onHide}>Close</Button>
          </Modal.Footer>
      </Modal>
  );
}

const CreativeUpload = () => {
  const [currentScreen, setCurrentScreen] = useState("existingFolder");
  const [selectedFileNames, setSelectedFileNames] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState<any>([]);
  const [S3UploaderPopUp, setS3UploaderPopUp] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [folderName, setFolderName] = useState("");
  // const [dspNames, setDspNames] = useState([])
  const [currentSelected, setCurrentSelected] = useState<any>([]); //Selected Files Object To Upload
  const [currentSelectedID, setCurrentSelectedID] = useState<any>([]); //Selected Files ID To maintain checkbox selection
  const [selectAll, setSelectAll] = useState(false); // USED FOR SELECT ALL FILES OPTION.
  const [createSubFolderPopup,setCreateSubFolderPopup] = useState(false);
  const [checkFolder,setCheckFolder] = useState(false);
  const [validFolder,setValidFolder] = useState(false);
  const [imgShow, setImgShow] = useState(false);
  const [finishedUpload,setFinishedUpload] = useState(false);
  const [imgShowURL, setImgShowURL] = useState('');
  const AuthState = useSelector((state: IReduxState) => state.Auth);

  const creativeUploadState = useSelector(
    (state: IReduxState) => state.CreativeUpload
  );
  const dispatch = useDispatch();

  

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#5369f8" : "white",
      color: state.isFocused ? "white" : "#4b4b5a",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#4b4b5a",
    }),
    control: (provided: any) => ({
      ...provided,
      // border: 'none',
      boxShadow: "none",
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: "none",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "gray",
    }),
  };

  const cleanupForms = ()=>{
    setCurrentSelected([]);
    setCurrentSelectedID([]);
    setFilesToUpload([]);
    setFolderName("");
    setSelectedFileNames([]);
    dspFormik.values.landingPage="";
    dspFormik.values.CreativeName="";
    dspFormik.values.creatives=[];
    dspFormik.values.campaign="";
    dspFormik.values.campaignName="";
  }

  const dspFormik = useFormik({
    initialValues: {
      landingPage: "",
      CreativeName: "",
      creatives: [],
      campaign:"",
      campaignName:""
    },
    onSubmit: (value, { resetForm }) => {
      //console.log(value);
    },
  });

  const createSubFolderForm = useFormik({
    initialValues:{
      folder_name:''
    },
    validationSchema: yup.object().shape({
      folder_name: yup.string().required("*"),
    }),
    onSubmit:(values,{resetForm})=>{
    }
  });

  useEffect(() => {
    dispatch(getAdvertiser());
  }, [dispatch]);


  useEffect(() => {
    dispatch(getLineItems());
  }, [dispatch]);

  const moveToTop = () => {
    const myMaybeNullElement = window.document.getElementById("top")
    if(myMaybeNullElement){
      myMaybeNullElement.scrollIntoView();
    }
  };


  useEffect(() => {
  }, [creativeUploadState]);

  const handleCheckFolderContent = () => {
     


     dispatch(
      getS3FilesAndFoldersAction(""
        // creativeUploadState.curFolder && currentSelectedID.length > 0
        //   ? creativeUploadState.curFolder
        //   : folderName ? pathCheck && pathCheck.length>0 && pathCheck[0]!==folderName? pathCheck[0] :folderName :'' 
      )
    );
  };
  const handleFolderClick = (folderNames: any) => {
    dispatch(getS3FilesAndFoldersAction(folderNames));
  };
  const handleValidateName = () => {
    dispatch(validateFolderNameAction(folderName));
    setShowValidationModal(true);
  };
  const handleClose = () => {
    setShowValidationModal(false);
  };

  const handleFolderBack = (folderNames: String) => {
    var subs = folderNames.split("/");
    if (subs.length > 2) {
      dispatch(
        getS3FilesAndFoldersAction(
          folderNames.substring(0, folderNames.indexOf(subs[subs.length - 2]))
        )
      );
    } else {  
      dispatch(getS3FilesAndFoldersAction(folderName?subs[0]!==folderName?subs[0]:folderName:''));
    }
  };

  const changeCamp =(option: any) => {
    // dspFormik.values.campaign = option.value;
    dspFormik.setFieldValue("campaign", option.value);
    dspFormik.setFieldValue("campaignName", option.label);
  };

  const handleUploadAllFiles = (e: any) => {
    let s3FilesArr = creativeUploadState.s3Files;

    let selectedArr = [...currentSelected];
    let selectedIDArr = [...currentSelectedID];

    s3FilesArr.forEach((file: any) => {
      var imageUrl =
        "https://cloud-images.s3.eu-west-1.amazonaws.com/" +
        creativeUploadState.curFolder +
        file.name;
      imageUrl = imageUrl.replaceAll(" ", "%20");
      const fname = creativeUploadState.curFolder + file.name;
      var obj = { fname: "", width: 0, height: 0, url: imageUrl };
      obj.fname = fname;
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        obj.height = img.height;
        obj.width = img.width;
      };

      if (e.target.checked) {
        if (!selectedIDArr.includes(file.id)) {
          selectedArr.push(obj);
          selectedIDArr.push(file.id);
        }

      } else {
        const index  = selectedArr.findIndex(x => x.fname ===fname);
        selectedArr.splice(index,1);  

        const indexID = selectedIDArr.indexOf(file.id);
        selectedIDArr.splice(indexID, 1);
      }
    });
    setCurrentSelected(selectedArr);
    setCurrentSelectedID(selectedIDArr);
    setSelectAll(e.target.checked);
  };

  const addToSelectedFiles = (file: any, e: any) => {
    var imageUrl =
      "https://cloud-images.s3.eu-west-1.amazonaws.com/" +
      creativeUploadState.curFolder +
      file.name;
    imageUrl = imageUrl.replaceAll(" ", "%20");
    const fname = creativeUploadState.curFolder + file.name;
    var obj = { fname: "", width: 0, height: 0, url: imageUrl };
    obj.fname = fname;
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      obj.height = img.height;
      obj.width = img.width;
    };
    let selectedArr = [...currentSelected];
    let selectedIDArr = [...currentSelectedID];
    if (e.target.checked) {
      selectedArr.push(obj);
      selectedIDArr.push(file.id);

      let s3FilesArr = creativeUploadState.s3Files;
      if (selectedIDArr.length === s3FilesArr.length) {
        setSelectAll(true);
      }
      
    } else {
      const index = selectedArr.findIndex((x) => x.fname === fname);
      selectedArr.splice(index, 1);

      const indexID = selectedIDArr.indexOf(file.id);
      selectedIDArr.splice(indexID, 1);
      if (selectAll) {
        setSelectAll(false);
      }
    }
    setCurrentSelected(selectedArr);
    setCurrentSelectedID(selectedIDArr);
  };

  const calcCurrentFolder = () => {
    if (creativeUploadState.curFolder !== "") {
      var arr = creativeUploadState.curFolder.split("/");
      return arr[arr.length - 2];
    } else {
      return "";
    }
  };

  const submitToDSP = () => {
    setFinishedUpload(true);
    var currentFolder = calcCurrentFolder();
    dispatch(
      uploadToDSP(
        selectedFileNames,
        dspFormik.values.landingPage,
        currentFolder,
        dspFormik.values.campaign,
        dspFormik.values.campaignName
      )
    );
  };

  const handleUploadToS3 = () => {
    var folder = creativeUploadState.curFolder;
    var ff = new FormData();
    ff.append("folder", "" + folder);
    filesToUpload.forEach((element: any) => {
      ff.append("data", element);
    });
    dispatch(uploadToS3(ff, folder));
    setSelectedFileNames([])
  };

  

  async function handleCreateSubFolder(): Promise<any> {
    try{
      const response = await axios.get(`validateName?folderName=${creativeUploadState.curFolder}${folderName}`);

      const {status} = response;
      if (status === 200) {
        dispatch(
          getS3FilesAndFoldersAction(`${creativeUploadState.curFolder}${folderName}/`)
        );
        setValidFolder(true);
        setCheckFolder(true);
        setCreateSubFolderPopup(false);
      }
    } catch (error:any) {
      setCheckFolder(true);
      setValidFolder(false);
    } 
  }
   
  return (
    <>
      {(['CreateFolder','existingFolder','DSPsubmit'].includes(currentScreen)) && (
        <Row className="d-flex justify-content-center mt-3">
          <Row>
            <h3 className="module_title" id="top">Creative Upload</h3>
          </Row>
        </Row>
      )}

      <Col className="transperent" style={{ padding: "12px" }}>
        {(currentScreen === "CreateFolder" ||
          currentScreen === "existingFolder") && (
          <>
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  <Row>
                    <Col lg={12} className="mb-2">
                      {currentScreen === "CreateFolder" && (
                        <Button
                          className="order-12 s3fileuploadexp"
                          style={{ margin: "0", width: "150px" }}
                          //variant="primary"
                          onClick={() => {
                            handleValidateName();
                          }}
                        >
                          Validate Name
                        </Button>
                      )}
                      {currentScreen === "existingFolder" && (
                        <Button
                          onClick={() => {
                            handleCheckFolderContent();
                            setCurrentScreen("S3Browser");
                          }}
                          className="order-12 s3fileuploadexp"
                          style={{ margin: "0", width: "160px" }}
                          //variant="primary"
                        >
                          Select/Upload Files
                        </Button>
                      )}
                    </Col>
                  </Row>
                  <Row>
                  <h4
                        style={{
                          fontSize: "15px",
                          margin: "0 0 7px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        selected files
                      </h4>
                      <Row style={{ marginBottom: "10px" }}>
                        <Table
                          responsive
                          className="table-nowrap table-centered mb-0"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "50%" }}>FileName</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedFileNames.map(
                              (filename: any, index: any) => (
                                <tr key={index}>
                                  <td style={{ width: "50%" }}>
                                    {filename.fname}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </Row>
                  </Row>
                </Card.Body>
              </Card>
            </Row>
            {currentScreen === "CreateFolder" && (
              <>
                {!showValidationModal && creativeUploadState.loading && (
                  <div className="popUpUser">
                    <Spinner className="m-2" color={"primary"}></Spinner>
                  </div>
                )}
                <Row style={{ marginBottom: "24px" }}>
                  <Col lg={6} style={{ paddingLeft: "0" }}>
                    <Card>
                      <Card.Body>
                        <FileUploader
                          onFileUpload={(files) => {
                            const namesArr: any = files.map((file) => {
                              const { path, dimensions } = file;
                              return `${path} ${dimensions}`;
                            });
                            setSelectedFileNames(namesArr);
                            setFilesToUpload(files);
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} style={{ paddingRight: "0" }}>
                    <Card style={{ height: "100%" }}>
                      <Card.Body>
                        <h4
                          style={{
                            fontSize: "15px",
                            margin: "0 0 7px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          UPLOADED FILE NAMES
                        </h4>
                        {selectedFileNames.map((filename: any) => (
                          <p>{filename}</p>
                        ))}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  {currentScreen === "CreateFolder" && (
                    <>
                      <Button
                        id="special-diabled-button"
                        style={{ marginBottom: "0" }}
                        variant="primary"
                        onClick={() => {
                          handleUploadToS3();
                        }}
                        disabled={
                          selectedFileNames && selectedFileNames.length > 0
                            ? false
                            : true
                        }
                      >
                        Upload to S3
                      </Button>
                      <Button
                        variant="secondary"
                        style={{ marginBottom: "0" }}
                        onClick={() => {
                          setCurrentScreen("DSPsubmit");
                        }}
                        id="special-diabled-button"
                        disabled={
                          selectedFileNames && selectedFileNames.length > 0
                            ? false
                            : true
                        }
                      >
                        Continue
                      </Button>
                    </>
                  )}
                  {currentScreen === "existingFolder" && (
                    <Button
                      onClick={() => {
                        setCurrentScreen("DSPsubmit");
                        moveToTop();
                      }}
                      style={{ margin: "0" }}
                      variant="primary"
                      disabled={
                        selectedFileNames && selectedFileNames.length > 0
                          ? false
                          : true
                      }
                    >
                      Continue
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Row>
          </>
        )}
        {currentScreen === "S3Browser" && (
          <>
            {creativeUploadState.loading && (
              <div className="popUpUser">
                <Spinner className="m-2" color={"primary"}></Spinner>
              </div>
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <h3
                style={{
                  color: "#343a40",
                  textAlign: "left",
                  fontSize: "1.05rem",
                  fontWeight: "600",
                }}
              >
                Folder Name:<p>{creativeUploadState.curFolder} </p>
              </h3>
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <ButtonGroup
                  className=" fsz-875rem"
                  style={{
                    width: "max-content",
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    style={{ margin: "0" }}
                    variant="light"
                    onClick={() => {
                      handleFolderBack(creativeUploadState.curFolder);
                    }}
                  >
                    <Back /> <span>Back</span>
                  </Button>
                </ButtonGroup>

                <Button
                  className="fsz-875rem"
                  variant="light"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "max-content",
                    margin: "0 0 0 8px",
                  }}
                  onClick={() => {
                    handleCheckFolderContent();
                  }}
                >
                  <House className="me-2 fsz-875rem" />
                  <span>Home</span>
                </Button>
              </div>
            </div>

            <h6 style={{ fontSize: "18px", fontWeight: "600" }}>Sub-Folders</h6>
            <Row>
              <Col xxl={3} lg={6}>
                <Button
                  onClick={() => {
                    setCreateSubFolderPopup(true);
                  }}
                  variant="info"
                >
                  + Create New Sub-Folder
                </Button>
              </Col>
            </Row>
            <Row>
              {(creativeUploadState.s3Folders || []).map(
                (f: any, i: number) => {
                  let folderDetails = f.name.split("/");

                  return (
                    <Col key={i} xxl={3} lg={6}>
                      <Card
                        className="shadow-none border"
                        style={{ marginBottom: "24px" }}
                      >
                        <div style={{ padding: "12px" }}>
                          <Row className="align-items-center">
                            <Col
                              className="col-auto"
                              style={{ marginLeft: "15px" }}
                            >
                              <div className="avatar-sm">
                                <span
                                  className={`avatar-title rounded fs-24 bg-soft-info text-info`}
                                  style={{ padding: "8px" }}
                                >
                                  <Folder size={24} color="#35c2e3" />
                                </span>
                              </div>
                            </Col>
                            <Col className="ps-1">
                              <Link
                                to="#"
                                style={{ textDecoration: "none" }}
                                className="text-muted fw-bold fs-15"
                              >
                                <span
                                  onClick={() => {
                                    handleFolderClick(f.name);
                                  }}
                                >
                                  {folderDetails[folderDetails.length - 2]}
                                  <br />
                                  <span style={{fontWeight:400,opacity:'0.7'}}>Last Modified: {moment(f.lastMod).format("DD/MM/YYYY")}</span>
                                </span>
                              </Link>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    </Col>
                  );
                }
              )}
            </Row>
            <Row>
              <Col xs={12}>
                <h6 style={{ fontSize: "18px", fontWeight: "600" }}>Files</h6>

                <Card>
                  <Card.Body>
                    
                    <Button
                      onClick={() => {
                        setS3UploaderPopUp(true);
                      }}
                      variant="info"
                    >
                      Upload to this folder
                    </Button>
                    <Button
                      style={{ width: "max-content" }}
                      onClick={() => {
                        setSelectedFileNames(currentSelected);
                        setCurrentScreen("existingFolder");
                      }}
                      variant="primary"
                    >
                      Choose Selected Files
                    </Button>
                    <Table
                      responsive
                      className="table-nowrap table-centered mb-0"
                    >
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="mastercheck"
                              onChange={(e) => handleUploadAllFiles(e)}
                              checked={selectAll}
                            />
                          </th>
                          <th>ID</th>
                          <th>Preview</th>
                          <th>FileName</th>
                          <th>Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(creativeUploadState.s3Files || []).map(
                          (file: any, index: number) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="mastercheck"
                                    onChange={(e) =>
                                      addToSelectedFiles(file, e)
                                    }
                                    checked={
                                      currentSelectedID.includes(file.id)
                                        ? true
                                        : false
                                    }
                                  />
                                </td>
                                <td>{file.id}</td>
                                <td><img src={`https://cloud-images.s3.eu-west-1.amazonaws.com/${creativeUploadState.curFolder}${file.name}`} alt={" "} height="50" width="120" onClick={()=>{
                                  setImgShow(true);
                                  setImgShowURL(`https://cloud-images.s3.eu-west-1.amazonaws.com/${creativeUploadState.curFolder}${file.name}`)
                                }}  /></td>
                                <td>{file.name}</td>
                                <td>{file.size}</td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <ModalImageShow
                show={imgShow}
                imgShowURL={imgShowURL}
                onHide={() => {
                  setImgShow(false);
                  setImgShowURL('');
                }}
            />
          </>
        )}
        {S3UploaderPopUp && (
          <>
            <div className="S3-Uploader-Popup">
              <div className="S3-Browser-Uploader">
                <Row style={{ marginBottom: "24px" }}>
                  <Col lg={6} style={{ paddingLeft: "0" }}>
                    <Card>
                      <Card.Body>
                        <FileUploader
                          onFileUpload={(files) => {
                            const namesArr: any = files.map((file) => {
                              const { path, dimensions } = file;
                              return `${path} ${dimensions}`;
                            });
                            setSelectedFileNames(namesArr);
                            setFilesToUpload(files);
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} style={{ paddingRight: "0" }}>
                    <Card style={{ height: "100%" }}>
                      <Card.Body>
                        <h4
                          style={{
                            fontSize: "15px",
                            margin: "0 0 7px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          UPLOADED FILE NAMES
                        </h4>
                        {selectedFileNames.map(
                          (filename: any, index: number) => (
                            <p>{filename}</p>
                          )
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Card>
                    <Card.Body>
                      <Button
                        variant="primary"
                        style={{ margin: "0px 10px 0px 0px" }}
                        onClick={() => {
                          handleUploadToS3();
                          setS3UploaderPopUp(false);
                        }}
                        disabled={
                          selectedFileNames && selectedFileNames.length > 0
                            ? false
                            : true
                        }
                      >
                        Upload to S3
                      </Button>
                      <Button
                        onClick={() => {
                          setS3UploaderPopUp(false);
                        }}
                        variant="light"
                        style={{ margin: "0" }}
                      >
                        Cancel
                      </Button>
                    </Card.Body>
                  </Card>
                </Row>
              </div>
            </div>
          </>
        )}
        {currentScreen === "DSPsubmit" && (
          <>
            {creativeUploadState.loading && (
              <div className="popUpUser">
                <Spinner className="m-2" color={"primary"}></Spinner>
              </div>
            )}
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  <Row style={{ marginBottom: "10px" }}>
                    <h4
                      style={{
                        fontSize: "15px",
                        margin: "0 0 7px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      DSP CREATIVE DATA
                    </h4>
                  </Row>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label
                      column
                      lg={3}
                      htmlFor="simpleinput"
                      id="smallerFontSize"
                    >
                      Landing Page URL
                    </Form.Label>
                    <Col lg={9}>
                      <Form.Control
                        name="landingPage"
                        type="text"
                        id="simpleinput"
                        value={dspFormik.values.landingPage}
                        onChange={dspFormik.handleChange}
                        onBlur={dspFormik.handleBlur}
                        className="fsz-875rem"
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label
                      column
                      lg={3}
                      htmlFor="simpleinput"
                      id="smallerFontSize"
                    >
                      Select Campaign
                    </Form.Label>
                    <Col lg={9}>
                    <Select
                              isMulti={false}
                              options={creativeUploadState.lineItems.map((x:any) => {
                                return { value: x.id, label: x.name+" - "+x.id };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={changeCamp}
                              onBlur={dspFormik.handleBlur}

                            ></Select>
                    </Col>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Row>
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  <Table
                    responsive
                    className="table-nowrap table-centered mb-0"
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "100%" }}>FileName</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      {selectedFileNames.map((filename: any, index: number) => (
                        <tr key={index}>
                          <td style={{ width: "100%" }}>{filename.fname}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Row>
            <Row>
              <Card>
                <Card.Body>
                  <Button
                    style={{ margin: "0" }}
                    variant="primary"
                    onClick={() => {
                      submitToDSP();
                      // setCurrentScreen("existingFolder");
                    }}
                    disabled={
                      (dspFormik.values.campaign !== "" &&
                      dspFormik.values.landingPage !== ""
                        ? creativeUploadState.loading
                          ? true
                          : false
                         : true)||(finishedUpload)
                    }
                  >
                    {" "}
                    Creative Upload
                  </Button>
                  {"  "}
                  {finishedUpload && (<Button
                    style={{margin: "0" }}
                    variant="primary"
                    onClick={() => {
                      // submitToDSP();
                      cleanupForms();
                      setFinishedUpload(false);
                      setCurrentScreen("existingFolder");
                    }}
                    
                  >
                    {" "}
                    Upload More
                  </Button>)}
                </Card.Body>
              </Card>
            </Row>
          </>
        )}
        {createSubFolderPopup && (
          <>
            <Modal
              show={createSubFolderPopup}
              onHide={() => {
                setCreateSubFolderPopup(false);
                setCheckFolder(false);
              }}
            >
              <Modal.Header
                style={{ borderBottom: "0" }}
                onHide={() => {
                  setCreateSubFolderPopup(false);
                  setCheckFolder(false);
                }}
                closeButton
              >
                <Modal.Title
                  as="h4"
                  style={{ fontSize: ".9375rem", fontWeight: "700" }}
                >
                  Create New Sub-Folder
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={4}
                    htmlFor="folder_name"
                    id="smallerFontSize"
                  >
                    Folder Name
                    {createSubFolderForm.errors.folder_name && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        {createSubFolderForm.errors.folder_name}
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={8}>
                    <FormControl
                      name="folder_name"
                      onChange={(e) => {
                        setCheckFolder(false);
                        setFolderName(e.target.value);
                        createSubFolderForm.handleChange(e);
                      }}
                      onBlur={createSubFolderForm.handleBlur}
                    ></FormControl>
                  </Col>
                </Form.Group>
                {!validFolder && checkFolder && (
                  <p
                    style={{
                      fontWeight: 700,
                      fontSize: "0.875rem !important",
                      color: "#ff0000",
                    }}
                  >
                    Folder name already exists. Please use a different name.
                  </p>
                )}
              </Modal.Body>
              <Modal.Footer style={{ borderTop: "0" }}>
                <Button
                  variant="light"
                  onClick={() => {
                    setCheckFolder(false);
                    setCreateSubFolderPopup(false);
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    if (
                      JSON.stringify(createSubFolderForm.errors) === "{}" &&
                      JSON.stringify(createSubFolderForm.touched) !== "{}"
                    ) {
                      handleCreateSubFolder();
                      // createSubFolderForm.handleSubmit();
                      // setCreateSubFolderPopup(false);
                    }
                  }}
                >
                  Save changes
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Col>
    </>
  );
};

export default CreativeUpload;